import { InteractionDto, InteractionStatus } from "@/repository/models";
import dayjs from "dayjs";

export const getLastElementIndexByQueuePriority = (
	interactions: InteractionDto[],
	interaction: InteractionDto
) => {
	if (!interactions.length) {
		return 0;
	}

	const filterByQueuePriority = interactions.filter(
		(element) => element.queuePriority === interaction.queuePriority
	);

	if (filterByQueuePriority.length) {
		return filterByQueuePriority.length;
	}

	return interactions.filter(
		(element) => element.queuePriority < interaction.queuePriority
	).length;
};

export const getLastElementIndexByStartDate = (
	interactions: InteractionDto[],
	interaction: InteractionDto
) => {
	if (!interactions.length) {
		return 0;
	}

	const interactionDate = dayjs(interaction.startDate);
	const index = interactions.findIndex(
		(i) =>
			interactionDate.isBefore(dayjs(i.startDate)) ||
			interactionDate.isSame(dayjs(i.startDate))
	);

	return index === -1 ? interactions.length : index;
};

export const getLastElementIndexForParkedCalls = (
	interactions: InteractionDto[]
) => {
	return interactions.filter((i) => i.status === InteractionStatus.Parked)
		.length;
};
